import { get, set } from 'lib/storage/isomorphicLocalStorage'

export const STORAGE_KEY = 'curatedTripOnboardingTooltip'
const HAS_DISMISSED_SUBKEY = 'hasDismissed'
const HAS_SAVED_SUBKEY = 'hasSaved'

const getKey = (...args: Array<string>) => args.join(':')

export function getHasDismissedOnboardingTooltip(): boolean {
  return get(getKey(STORAGE_KEY, HAS_DISMISSED_SUBKEY)) ?? false
}

export function setHasDismissedOnboardingTooltip(flag: boolean) {
  set(getKey(STORAGE_KEY, HAS_DISMISSED_SUBKEY), flag)
}

export function getHasSavedTemplateOrItem(): boolean {
  return get(getKey(STORAGE_KEY, HAS_SAVED_SUBKEY)) ?? false
}

export function setHasSavedTemplateOrItem(flag: boolean) {
  return set(getKey(STORAGE_KEY, HAS_SAVED_SUBKEY), flag)
}
